// extracted by mini-css-extract-plugin
export default {"resource":"style_resource__IAld3","qtd":"style_qtd__J0Q6f","value":"style_value__4Ke5n","provider":"style_provider__B5xgu"};